// Audience cluster — stránky pro konkrétní typy týmů. Používá sdílený mkIntent builder.
import { mkIntent } from "./intents";

export const AUDIENCES = [
  mkIntent({
    slug: "teambuilding-pro-startupy",
    breadcrumb: "Teambuilding pro startupy",
    overline: "TEAMBULDING PRO STARTUPY",
    title: "Teambuilding pro startupy | Mission Ještěd",
    description: "Teambuilding pro startupy a scale-upy: Mission Ještěd bez korporátní nudy. Rychlá domluva, transparentní cena, akce pro 10–50 lidí i na poslední chvíli.",
    h1: "Teambuilding pro startupy bez korporátní nudy",
    heroSub: "Žádné trust fally, žádné povinné kruhy. Mapa, časový limit, Ještěd a večer soukromý Warehouse. Startupové tempo, startupová domluva.",
    img: "forestMission",
    answerQ: "Proč Mission Ještěd pro startup?",
    answerShort: "Protože je to produkt, ne animační program. Rychlá poptávka, jasná cena předem (Mission 24 od 4 990 Kč/os., min. 129 000 Kč za akci), jedna domluva a akce, která sedí týmům zvyklým na rychlé rozhodování pod tlakem.",
    answerDetail: [
      "Startupové týmy oceňují, že scoring odměňuje strategii a spolupráci víc než kondici — přesně jako ve firmě.",
      "Menší tým? Minimální cena akce Mission 24 je 129 000 Kč, jednodenní Mission umíme i pro deset lidí. Přesnou konfiguraci navrhneme v nabídce.",
    ],
    sections: [
      {
        kicker: "TEMPO",
        heading: "Od poptávky k misi bez měsíců příprav",
        paras: [
          "Stačí počet lidí, termín a rozpočet. Návrh mise s cenou připravíme do několika pracovních dnů a mimo hlavní sezónu umíme i kratší dodací lhůty.",
          "Dopravu, jídlo, ubytování i večer řešíme my — váš ops člověk na to nemusí alokovat ani den.",
        ],
        img: "envelope",
      },
      {
        kicker: "KULTURA",
        heading: "Zážitek, který sedí startupové kultuře",
        paras: [
          "Žádné dětinské aktivity. Mise je dospělá výzva: nejistota, časový tlak, rozhodování. Večer Warehouse s DJ — soukromě, bez cizích lidí.",
          "Pro remote-first startupy je to často jediný den v roce, kdy je celý tým fyzicky pohromadě. Stojí za to z něj udělat pořádný zážitek.",
        ],
      },
    ],
    faq: [
      { q: "Jsme startup s 12 lidmi — má to smysl?", a: "Ano. Mission 24 má minimální cenu akce 129 000 Kč (odpovídá 20 lidem), pro menší tým zaplatíte stejné minimum. Alternativně jednodenní Mission od 2 490 Kč na osobu." },
      { q: "Umíte akci i v angličtině?", a: "Ano. Briefing, Mission Pack i instruktoři umí celou misi v angličtině — viz stránka teambuilding v angličtině." },
      { q: "Jak rychle umíte akci zorganizovat?", a: "Mimo sezónu typicky 3–4 týdny od poptávky, podzim a předvánoční termíny doporučujeme 6–8 týdnů. Napište nám termín — ozveme se s možnostmi." },
    ],
    related: [
      { href: "/teambuilding-pro-remote-team", title: "Teambuilding pro remote týmy", text: "Pro týmy, které se vidí hlavně na callech." },
      { href: "/teambuilding-pro-it-firmy", title: "Teambuilding pro IT firmy", text: "Šifry, logika, offline den." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-pro-remote-team",
    breadcrumb: "Teambuilding pro remote tým",
    overline: "TEAMBULDING PRO REMOTE TÝM",
    title: "Teambuilding pro remote týmy | Mission Ještěd",
    description: "Teambuilding pro remote a hybridní týmy: jediný den v roce, kdy je celý tým pohromadě. Mission Ještěd — offline mise, ubytování a soukromá party.",
    h1: "Teambuilding pro remote tým: jediný den, kdy jste všichni fyzicky pohromadě",
    heroSub: "Znáte se z callů, Slacku a sdílených dokumentů. Mission Ještěd vás postaví do jednoho lesa s jednou mapou — a večer do jednoho klubu.",
    img: "summit",
    answerQ: "Jak zorganizovat teambuilding pro remote tým?",
    answerShort: "Sraz udělejte přímo ve Warehouse Liberec (Hanychovská 10) — každý dorazí vlastní cestou, nebo sjedeme společný autobus z Prahy. O vše ostatním se postaráme: mise, jídlo, ubytování, večer.",
    answerDetail: [
      "U remote týmů je logistika největší překážka — proto ji řešíme celou my. Lidem stačí termín a doporučené oblečení.",
      "Ubytování v ceně Mission 24 znamená, že nikdo nemusí po party řešit cestu domů přes půl republiky.",
    ],
    sections: [
      {
        kicker: "PROČ OFFLINE",
        heading: "Vztahy, které se nestaví přes obrazovku",
        paras: [
          "Checkpointy vyžadují fyzickou spolupráci: jeden čte mapu, druhý hlídá čas, třetí řeší úkol. Role, které v remote práci neexistují.",
          "Sdílená nepohoda (déšť, mlha, časový tlak) vytváří historky, které tým vypráví na callech ještě měsíce potom.",
        ],
        img: "forestMission",
      },
      {
        kicker: "LOGISTIKA",
        heading: "Sraz tam, kde to dává smysl pro všechny",
        paras: [
          "Praha je pro rozptýlené týmy typicky nejlepší sraz — náš autobus odtud vyjede před dohodnutým místem a odveze celý tým do Liberce.",
          "Pro mezinárodní týmy umíme vyzvednutí na letišti Václava Havla. Detaily dopravy navrhneme v nabídce.",
        ],
      },
    ],
    faq: [
      { q: "Lidé jsou z celé republiky — jak vyřešíme dopravu?", a: "Nejjednodušší je společný autobus z Prahy, případně individuální příjezd na sraz do Warehouse Liberec. Oba varianty sladíme s harmonogramem mise." },
      { q: "Stojí to za to na jediný den?", a: "Proto doporučujeme Mission 24: když už se remote tým sejde, ať z toho je celých 24 hodin — mise, večeře, party, nocleh i snídaně." },
      { q: "Část týmu je z ciziny — je problém?", a: "Ne. Mise umí běžet paralelně česky i anglicky a stravovací omezení vyřešíme předem. Napište složení týmu do poptávky." },
    ],
    related: [
      { href: "/teambuilding-pro-mezinarodni-tym", title: "Teambuilding pro mezinárodní tým", text: "CZ/EN delivery, logistika z letiště." },
      { href: "/teambuilding-s-dopravou", title: "Teambuilding s dopravou", text: "Autobus od kanceláře i z Prahy." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-pro-mezinarodni-tym",
    breadcrumb: "Teambuilding pro mezinárodní tým",
    overline: "TEAMBULDING PRO MEZINÁRODNÍ TÝMY",
    title: "Teambuilding pro mezinárodní týmy | Mission Ještěd CZ/EN",
    description: "Firemní teambuilding pro mezinárodní týmy v ČR: Mission Ještěd v češtině i angličtině, doprava z Prahy či letiště, ubytování a soukromá Warehouse party.",
    h1: "Teambuilding pro mezinárodní tým: jedna mise, dva jazyky, nula bariér",
    heroSub: "Briefing česky i anglicky. Mission Pack v obou jazycích. Instruktoři, kteří drží tempo obou jazykových skupin najednou.",
    img: "qrCheckpoint",
    answerQ: "Umíte teambuilding pro smíšený česko-anglický tým?",
    answerShort: "Ano. Mission Ještěd umíme dodat kompletně v angličtině nebo bilingvně — briefing, instrukce v Mission Packu, checkpointy i večerní vyhlášení. Jazyková verze se domlouvá před akcí.",
    answerDetail: [
      "Týmové úkoly jsou navržené tak, aby fungovaly bez dokonalé společné řeči — komunikace je součást hry, ne překážka.",
      "Pro hosty ze zahraničí je Ještěd a česká horská krajina zážitek sám o sobě — a Warehouse party večer taky.",
    ],
    sections: [
      {
        kicker: "LOGISTIKA",
        heading: "Vyzvednutí na letišti nebo v Praze",
        paras: [
          "Pro mezinárodní týmy typicky startujeme v Praze — autobus vyzvedne skupinu na letišti Václava Havla nebo u hotelu a odveze ji do Liberce.",
          "Harmonogram sladíme s přílety: arrival ve Warehouse lze posunout, mise startuje po obědě.",
        ],
        img: "heroArrival",
      },
      {
        kicker: "DETAILY",
        heading: "Na co myslíme u mezinárodních skupin",
        list: [
          "Bilingvní nebo plně anglický program dle složení týmu",
          "Stravovací omezení a alergie sbíráme předem",
          "Dietní varianty večeře i snídaně",
          "Foto/video z akce pro interní komunikaci mateřské firmy",
        ],
        paras: [],
      },
    ],
    faq: [
      { q: "Je celá mise dostupná v angličtině?", a: "Ano — briefing, Mission Pack, instruktoři i večerní vyhlášení. Viz stránka teambuilding v angličtině." },
      { q: "Zajistíte dopravu z letiště?", a: "Ano, autobus z letiště Václava Havla nebo od hotelu v Praze. Cenu nabídneme v kalkulaci podle trasy a velikosti skupiny." },
      { q: "Jaké je ideální datum pro zahraniční kolegy?", a: "Doporučujeme středu–pátek: zahraniční kolegové přiletí, akce proběhne, v pátek odletí. Letní a podzimní termíny mají nejstabilnější počasí." },
    ],
    related: [
      { href: "/teambuilding-v-anglictine", title: "Teambuilding v angličtině", text: "Celá mise v EN." },
      { href: "/company-retreat-czech-republic", title: "Company retreat in Czech Republic", text: "English page for international teams." },
      { href: "/teambuilding-praha", title: "Teambuilding Praha", text: "Logistika z Prahy." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-v-anglictine",
    breadcrumb: "Teambuilding v angličtině",
    overline: "TEAMBULDING V ANGLIČTINĚ",
    title: "Teambuilding v angličtině | Mission Ještěd EN delivery",
    description: "Firemní teambuilding kompletně v angličtině: Mission Ještěd s EN briefingem, EN Mission Packem a EN instruktory. Pro české firmy s anglicky mluvícími týmy.",
    h1: "Teambuilding v angličtině. Celá mise, žádný překlad přes rameno.",
    heroSub: "Briefing, Mission Pack, checkpointy, instruktoři i večerní vyhlášení — kompletně v angličtině. Čeští kolegové si odpočinou od simultánního překladu.",
    img: "mapTable",
    answerQ: "Děláte teambuilding kompletně v angličtině?",
    answerShort: "Ano. Mission Ještěd dodáváme v plné anglické verzi: briefing, tištěné instrukce, týmové úkoly, instruktoři na checkpointech i večerní program ve Warehouse. Anglická verze se domlouvá při objednávce.",
    answerDetail: [
      "Pro smíšené týmy umíme bilingvní režim — část materiálů česky, část anglicky, instruktoři přepínají podle týmu.",
      "Herní design mise nezávisí na jazykových hříčkách — úkoly jsou logické a komunikační, ne slovní.",
    ],
    sections: [
      {
        kicker: "JAK TO FUNGUJE V EN",
        heading: "Stejná mise, anglické provedení",
        paras: [
          "Program je identický s českou verzí: arrival, briefing, drop, mise s checkpointy, finish na Ještědu, večeře, vyhlášení a Warehouse party.",
          "Jediný rozdíl je jazyk instrukcí a komunikace. Scoring, trasa i časový plán zůstávají stejné.",
        ],
        img: "forestMission",
      },
      {
        kicker: "PRO KOHO",
        heading: "Pro firmy s EN-speaking kolegy",
        paras: [
          "Typicky pražské a brněnské pobočky mezinárodních firem, startupy s distributed týmy a firmy po akvizicích, kde se spojují CZ a zahraniční týmy.",
          "Cena je stejná jako u české verze — angličtina není upsell.",
        ],
      },
    ],
    faq: [
      { q: "Je anglická verze dražší?", a: "Ne. Cena je stejná jako u české verze — jazykovou verzi jen domluvíme před akcí." },
      { q: "Zvládnou instruktoři EN na všech checkpointech?", a: "Ano. Instruktoři pro EN akce jsou vybíraní podle jazykové úrovně — komunikace na trati je plně anglická." },
      { q: "Umíte i jiný jazyk než češtinu a angličtinu?", a: "Standardně dodáváme česky a anglicky. Jiné jazyky (např. němčinu) umíme probrat individuálně podle termínu." },
    ],
    related: [
      { href: "/teambuilding-pro-mezinarodni-tym", title: "Mezinárodní týmy", text: "CZ/EN týmy a logistika." },
      { href: "/company-retreat-czech-republic", title: "Company retreat in Czech Republic", text: "English page." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "Kompletní program mise." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
    ],
  }),
  mkIntent({
    slug: "teambuilding-pro-hr",
    breadcrumb: "Teambuilding pro HR",
    overline: "TEAMBULDING PRO HR",
    title: "Teambuilding pro HR oddělení | Mission Ještěd bez starostí",
    description: "Teambuilding z pohledu HR: jedna poptávka, jedna smlouva, jedna faktura. Mission Ještěd s dokumentací pro schválení, weather planem a duty of care.",
    h1: "Teambuilding pro HR: jedna poptávka, jedna faktura, žádná koordinace pěti dodavatelů",
    heroSub: "Mission Ještěd je produkt s jasnou cenou, programem a bezpečnostním rámcem. HR dostane podklady pro schválení — ne další projekt na půl úvazku.",
    img: "envelope",
    answerQ: "Co HR potřebuje k objednání Mission Ještěd?",
    answerShort: "Počet lidí, termín a rozpočet. My dodáme nezávazný návrh s programem, rozpisem ceny a bezpečnostním rámcem ke schválení. Po schválení smlouva, fakturace na Warehouse club Liberec s.r.o. a koordinační schůzka před akcí.",
    answerDetail: [
      "Cena je jasná předem: Mission 24 od 4 990 Kč na osobu, minimální cena akce 129 000 Kč. Orientační příklady pro 20–50 lidí najdete v ceníku.",
      "Žádné skryté náklady: doprava, upsells i všechna jídla jsou rozepsané v nabídce.",
    ],
    sections: [
      {
        kicker: "PODKLADY PRO SCHVÁLENÍ",
        heading: "Dokumentace, kterou vedení chce vidět",
        list: [
          "Kompletní program s časovým harmonogramem",
          "Rozpis ceny: co je v ceně, co je upsell",
          "Bezpečnostní rámec a weather plan",
          "Smlouva a fakturace na Warehouse club Liberec s.r.o. (IČO 19829451)",
          "Koordinátor akce jako jediný kontaktní bod",
        ],
        paras: [],
      },
      {
        kicker: "CITLIVÉ TÉMA",
        heading: "Fotografie a souhlasy",
        paras: [
          "Součástí Mission 24 je fotograf. Fotografie slouží primárně firmě — promítají se večer a po akci je předáváme. Použití pro marketing řešíme jen se souhlasy, případně fotografujeme anonymně.",
          "Údaje z poptávky zpracováváme podle zásad ochrany osobních údajů — žádné sdílení třetím stranám mimo dodavatele akce.",
        ],
      },
    ],
    faq: [
      { q: "Dostaneme podklady pro interní schválení rozpočtu?", a: "Ano. Návrh mise obsahuje program, rozpis ceny a bezpečnostní rámec — dokument, který jde rovnou na schválení vedení." },
      { q: "Jak řešíte bezpečnost a odpovědnost?", a: "Mise vede značeným terénem, každý tým má nouzový kontakt, instruktoři jsou na checkpointech. Žádné nebezpečné překážky — adrenalin vzniká z časového tlaku, ne rizika." },
      { q: "Co když se počet účastníků změní?", a: "Menší výkyvy počtu řešíme bez problémů do dohodnutého termínu před akcí. Finální počty potvrzujeme v koordinační schůzce." },
    ],
    related: [
      { href: "/pro-firmy", title: "Pro firmy", text: "Jak spolupráce probíhá krok za krokem." },
      { href: "/bezpecnost", title: "Bezpečnost", text: "Extreme experience, safe execution." },
      { href: "/cenik", title: "Ceník", text: "Balíčky a orientační ceny." },
      { href: "/pruvodce/checklist-pro-hr-teambuilding", title: "Checklist pro HR", text: "Na co nezapomenout před akcí." },
    ],
  }),
  mkIntent({
    slug: "company-retreat-czech-republic",
    breadcrumb: "Company retreat Czech Republic",
    overline: "COMPANY RETREAT · CZECH REPUBLIC",
    lang: "en",
    title: "Company Retreat in Czech Republic | Mission Ještěd",
    description: "Company retreat in the Czech Republic for international teams: Mission Ještěd — a 24-hour guided team mission with accommodation, catering and a private club night in Liberec, 1h from Prague.",
    h1: "Company retreat in the Czech Republic your team hasn't done before",
    heroSub: "One morning your team boards a bus in Prague. A few hours later they get a map, a set of instructions and one objective: get the whole team to the top of Ještěd mountain.",
    img: "summit",
    answerQ: "What is Mission Ještěd?",
    answerShort: "Mission Ještěd is a 24-hour corporate retreat near Liberec, Czech Republic: a guided outdoor team mission with checkpoints in the Ještěd mountains, accommodation, dinner, and a private club night with DJ at Warehouse Liberec. Fully delivered in English.",
    answerDetail: [
      "Everything is handled by one supplier — transport from Prague, the mission, food, accommodation and the evening venue. One inquiry, one coordinator, one invoice.",
      "Indicative pricing: Mission 24 from CZK 4,990 per person (approx. EUR 200), minimum event value CZK 129,000. Final quote depends on dates and configuration.",
    ],
    sections: [
      {
        kicker: "LOGISTICS",
        heading: "From Prague airport to the mission start",
        paras: [
          "We pick your team up at Václav Havel Airport Prague or at your hotel. The drive to Liberec takes roughly 1–1.5 hours depending on traffic.",
          "A typical schedule: morning pickup in Prague, 11:00 arrival and check-in at Warehouse Liberec, 13:30 mission start, 17:00 finish at Ještěd summit, dinner, awards and a private Warehouse party until 02:00. Breakfast and check-out the next morning.",
        ],
        img: "heroArrival",
      },
      {
        kicker: "THE EXPERIENCE",
        heading: "A mission, not a workshop",
        paras: [
          "Teams receive a Mission Pack with a map and first instructions. Checkpoints across the Ještěd ridge test orientation, communication, leadership and decisions under time pressure.",
          "The fastest individual doesn't win — the team that works together does. Scoring: 30 % time, 40 % completed tasks, 20 % teamwork, 10 % bonus challenges.",
        ],
      },
    ],
    faq: [
      { q: "Is the retreat available in English?", a: "Yes. Briefing, Mission Pack, instructors and the evening program are fully in English. Czech-English bilingual format is also possible." },
      { q: "How do we get there from Prague?", a: "We arrange a bus from your Prague office, hotel or the airport — door to door. Transport pricing is included in your tailored quote." },
      { q: "What group size do you support?", a: "Standard format is 20–50 people; we can run formats from 10 up to 100 with wave starts. Minimum event value for Mission 24 is CZK 129,000." },
    ],
    related: [
      { href: "/teambuilding-v-anglictine", title: "Teambuilding v angličtině", text: "Česká verze stránky o EN delivery." },
      { href: "/mission-jested", title: "Mission Ještěd", text: "The complete 24-hour program." },
      { href: "/cenik", title: "Pricing", text: "Packages and indicative prices." },
      { href: "/poptavka", title: "Inquiry", text: "Get a tailored proposal." },
    ],
  }),
];
